import axios from 'axios';
import { getAuthHeaders } from './auth';

const API_PATH = process.env.REACT_APP_API_BASE_URL;


// Create axios instance with default config
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || API_PATH,
  timeout: 30000,
  withCredentials: true,
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Add auth headers to all requests
    const headers = getAuthHeaders() as Record<string, string>;
    Object.keys(headers).forEach(key => {
      config.headers.set(key, headers[key]);
    });
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Get current page path
const getCurrentPath = () => {
  return window.location.pathname;
};

// List of paths that should be accessible for unauthorized users
const publicPaths = ['/buy-sessions'];

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized error
      console.error('Authentication error:', error.response.data);
      
      // Only redirect if not accessing a public endpoint or page
      const requestUrl = error.config?.url || '';
      const currentPath = getCurrentPath();
      const isPublicPage = publicPaths.some(path => currentPath.includes(path));
      
      if (!requestUrl.includes('/public') && !isPublicPage) {
        // Clear token and redirect to login if needed
        localStorage.removeItem('token');
        window.location.href = '/register';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance; 